// extracted by mini-css-extract-plugin
module.exports = {"undoPageBody":"_3SBfQw","undoPageOptions":"_3U11YC","undoPageFooter":"_1GTlNO"};